import { gsap } from 'gsap';
import Flickity from 'flickity';

/**
 * Class representing components for managing different UI components.
 */
export class Components {
    
    /**
     * Constructs a Components object.
     */
    constructor() {
        this.menu();
        this.headerMenu();
        this.carousel();
        this.heroCarousel();
        this.accordions();
    }

    /**
     * Accordions (FAQs, About, etc.) – delegated so dynamically rendered blocks still work.
     */
    accordions() {
        $(document).on('click', 'article.accordion > .heading', function (event) {
            event.preventDefault();

            const $article = $(this).closest('article.accordion');
            $article.siblings('article.accordion').removeClass('open');
            $article.addClass('open');
        });
    }

    menu() {
        let body = $('body'),
            overlay = $('#overlay');
        
        // Function to toggle menu and body class
        function toggleMenu() {
            $('nav.menu').toggleClass('open');
            body.toggleClass('menu');
            body.toggleClass('fixed');
            body.removeClass('scrolling');
            overlay.toggleClass('open');

            // Update label text
            if ($('nav.menu').hasClass('open')) {
                $('.burger .label-menu').text('Close');
            } else {
                $('.burger .label-menu').text('Menu');
            }
        }
        
        // Click event for burger button in nav.menu
        $('.burger').on('click', function () {
            $(this).toggleClass('open');
            toggleMenu();
        });
    }

    /**
     * Header mobile menu (burger).
     */
    headerMenu() {
        let burger = $('.header__burger');
        let menu = $('#header-menu');
        let closeBtn = $('.header__menu-close');
        let backdrop = $('.header__menu-backdrop');

        function openMenu() {
            menu.addClass('is-open');
            burger.addClass('is-open').attr('aria-expanded', 'true');
            menu.attr('aria-hidden', 'false');
            $('body').addClass('menu-open');
        }

        function closeMenu() {
            menu.removeClass('is-open');
            burger.removeClass('is-open').attr('aria-expanded', 'false');
            menu.attr('aria-hidden', 'true');
            $('body').removeClass('menu-open');
        }

        burger.on('click', function () {
            if (menu.hasClass('is-open')) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        closeBtn.on('click', closeMenu);
        backdrop.on('click', closeMenu);

        menu.find('a').on('click', function () {
            closeMenu();
        });
    }
    
    /**
     * Initializes carousels using Flickity within sections of the main slider.
     *
     * This function searches for elements with the class `.main .slider` and initializes
     * Flickity carousels within each of them. It sets up the next/previous button controls,
     * updates their states based on the current slide index, and handles dot navigation.
     *
     * @returns {boolean} False if no sections are found; otherwise, void.
     */
    carousel() {
        let sections = gsap.utils.toArray('.slider');

        if (!sections.length) {
            return false;
        }

        sections.forEach(section => {
            let $section = $(section),
                main = $('.main-carousel', section)[0],
                next = $section.find('.next'),
                prev = $section.find('.prev'),
                dots = $section.find('.dots'),
                li = dots.find('li'),
                isAutoplay = $section.hasClass('slider--autoplay'),
                hasArrows = next.length && prev.length,
                cellAlign = $section.hasClass('slider--right') ? 'right' : ($section.hasClass('slider--center') ? 'center' : 'left');

            var slider = new Flickity(main, {
                cellAlign: cellAlign,
                contain: cellAlign === 'center' ? false : true,
                percentPosition: cellAlign === 'center' ? false : true,
                pageDots: false,
                prevNextButtons: false,
                autoPlay: isAutoplay ? 4000 : false,
                wrapAround: isAutoplay,
            });

            if (cellAlign === 'center') {
                requestAnimationFrame(() => slider.resize());
            }

            slider.on('select', function() {
                let index = slider.selectedIndex;
                li.removeClass('active');
                li.eq(index).addClass('active');
            });

            dots.on('click', 'li', function() {
                var index = $(this).index();
                slider.select(index);
            });

            if (hasArrows) {
                next.on('click', function() { slider.next(); });
                prev.on('click', function() { slider.previous(); });
            }
        });
    }

    /**
     * Hero carousel: syncs background slides, main copy slides, and (when present) bottom strip + Flickity.
     * Single-slide heroes (e.g. variation 2) get no auto-advance timer.
     */
    heroCarousel() {
        const $heroes = $('section.hero');
        if (!$heroes.length) {
            return false;
        }

        $heroes.each(function () {
            const $hero = $(this);
            const $bgSlides = $hero.find('.hero__bg-slide');
            const $contentSlides = $hero.find('.hero__content-slide');
            const $carousel = $hero.find('.carousel');

            if (!$bgSlides.length) {
                return;
            }

            const slideCount = $bgSlides.length;
            let activeIndex = 0;
            let slider = null;
            let autoTimer = null;
            const duration = 5;

            const main = $carousel.find('.main-carousel')[0];
            const prev = $carousel.find('.prev');
            const next = $carousel.find('.next');
            const item = $carousel.find('.cell');
            const fill = $carousel.find('[data-fill]');

            function stopAuto() {
                if (autoTimer) {
                    clearTimeout(autoTimer);
                    autoTimer = null;
                }
            }

            function setActive(index) {
                stopAuto();
                activeIndex = (index + slideCount) % slideCount;

                $contentSlides
                    .removeClass('is-active opacity-100 z-[2] pointer-events-auto')
                    .addClass('opacity-0 z-0 pointer-events-none');
                $contentSlides.eq(activeIndex)
                    .removeClass('opacity-0 z-0 pointer-events-none')
                    .addClass('is-active opacity-100 z-[2] pointer-events-auto');

                $bgSlides.removeClass('opacity-100 is-active').addClass('opacity-0');
                $bgSlides.eq(activeIndex).removeClass('opacity-0').addClass('opacity-100 is-active');

                if ($carousel.length && item.length) {
                    item.removeClass('is-active');
                    item.eq(activeIndex).addClass('is-active');
                    fill.css({ width: '0', transition: 'none' });
                    fill.eq(activeIndex).css('transition', 'width ' + duration + 's linear');
                    fill.eq(activeIndex).css('width', '100%');
                }

                if (slideCount <= 1) {
                    return;
                }

                autoTimer = setTimeout(function () {
                    if (slider) {
                        slider.next();
                    } else {
                        setActive(activeIndex + 1);
                    }
                }, duration * 1000);
            }

            function init() {
                stopAuto();
                if (slider) {
                    activeIndex = slider.selectedIndex;
                    slider.destroy();
                    slider = null;
                }
                if ($carousel.length && main) {
                    if (window.matchMedia('(min-width: 1410px)').matches) {
                        setActive(activeIndex);
                    } else {
                        slider = new Flickity(main, {
                            cellAlign: 'left',
                            contain: true,
                            pageDots: false,
                            prevNextButtons: false,
                            groupCells: 1,
                            wrapAround: true,
                        });
                        slider.on('select', function () {
                            setActive(slider.selectedIndex);
                        });
                        setActive(activeIndex);
                    }
                } else {
                    setActive(activeIndex);
                }
            }

            if ($carousel.length) {
                prev.on('click', function () {
                    if (slider) {
                        slider.previous();
                    } else {
                        setActive(activeIndex - 1);
                    }
                });

                next.on('click', function () {
                    if (slider) {
                        slider.next();
                    } else {
                        setActive(activeIndex + 1);
                    }
                });
            }

            init();
            window.addEventListener('resize', init);
        });
    }
}
